import { IOPASS_AUTHORIZE_URL } from "@shared/index";

const IOPASS_CLIENT_ID = import.meta.env.VITE_IOPASS_CLIENT_ID || "iop_3f3e8964b3373e6b872eb33cf2e4b502";

/**
 * Generate PKCE code verifier and challenge
 */
async function generatePKCE() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  const verifier = btoa(String.fromCharCode(...array))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");

  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  const challenge = btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");

  return { verifier, challenge };
}

/**
 * Redirect to IOPass login with PKCE
 * @param returnPath - path to redirect to after login
 * @param inviteToken - optional invite token for claiming an invite
 */
export async function redirectToLogin(returnPath = "/", inviteToken?: string) {
  const { verifier, challenge } = await generatePKCE();
  const state = crypto.randomUUID();
  const redirectUri = `${window.location.origin}/api/oauth/callback`;

  // Store PKCE data in sessionStorage
  sessionStorage.setItem("iopass_pkce_verifier", verifier);
  sessionStorage.setItem("iopass_redirect_uri", redirectUri);
  sessionStorage.setItem("iopass_return_path", returnPath);
  sessionStorage.setItem("iopass_state", state);

  // Store invite token if present (for invite claim flow)
  if (inviteToken) {
    sessionStorage.setItem("iopass_invite_token", inviteToken);
  }

  const params = new URLSearchParams({
    response_type: "code",
    client_id: IOPASS_CLIENT_ID,
    redirect_uri: redirectUri,
    scope: "openid profile email",
    state,
    code_challenge: challenge,
    code_challenge_method: "S256",
  });

  window.location.href = `${IOPASS_AUTHORIZE_URL}?${params}`;
}

/**
 * Logout
 */
export async function logout() {
  await fetch("/api/v1/auth/logout", { method: "POST", credentials: "include" });
  window.location.href = "/";
}
